<template>
  <table-column-element
    v-bind="$attrs"
    v-on="$listeners"
    :align="this.$attrs.align || 'right'"
    :label="computedLabel"
  >
    <template slot-scope="{row}">
      <number 
        :number="row | get($attrs.prop)"
        :currencySymbol="currencySymbol"
      />
    </template>
  </table-column-element>
</template>

<script>
export default {
  props: {
    currencySymbol: { type: String, default: null },
    tableColumnType: { type: String, default: 'number' },
    label: { type: String, default: '' },
  },
  computed: {
    computedLabel() {
      return this.currencySymbol ? `${this.label}, ${this.currencySymbol}` : this.label;
    }
  },
  methods: {
    isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/table-column-number.vue